// Libraries
import { ReactNode } from 'react';

// Hooks
import { useAppDispatch, useAppSelector } from '../../../app/hooks';

// Features
import { clearModalContent } from '../../../features/app/appSlice';
import { selectUser } from '../../../features/user/userSlice';

// Components
import Button from '../../atoms/Button/Button';
import ModalContent from './ModalContent';

/**
 * @function ModalContentInsufficientTokens
 * Describe the ModalContentInsufficientTokens's function
 *
 * @example
 * return (
 *   <ModalContentInsufficientTokens />
 * )
 */
function ModalContentInsufficientTokens(): JSX.Element {
    const dispatch = useAppDispatch();
    const user = useAppSelector(selectUser);
    const playId = user.external_member_level > 3 ? 1 : 2;

    function handleCloseClick() {
        dispatch(clearModalContent());
    }

    return (
        <ModalContent>
            <>
                <h2>
                    Not enough <b>port points</b>
                </h2>
                <p>
                    You don't have enough port points (<b>5,000 PP</b>) to{' '}
                    <b>buy</b> an Access Token.
                </p>
                <p>
                    You can either{' '}
                    <a
                        href={`https://${process.env.REACT_APP_LOGIN_URL}/play/${playId}`}
                    >
                        spin the wheel
                    </a>{' '}
                    to instantly top up your port points, or check out our{' '}
                    <a
                        href={`https://${process.env.REACT_APP_LOGIN_URL}/how-to-earn`}
                    >
                        How to Earn Port Points guide
                    </a>{' '}
                    to find out even more ways to gain port points.
                </p>
                <p>
                    Access Tokens can also be <b>won</b> in '
                    <b>Token Tourneys</b>'
                </p>
                <Button
                    text="Back to Lobby"
                    style="primary"
                    onClick={() => handleCloseClick()}
                />
            </>
        </ModalContent>
    );
}

// Exports
export default ModalContentInsufficientTokens;
